import { useEffect, useState } from 'react';
import ReferralDS from '../../DataServices/ReferralDs';
import { insertLog } from '../Logs/InsertLog';
import { useCustomContext } from '../CustomComponents/CustomComponents';
import { useNavigate } from 'react-router-dom';
import userPoolData from '../../UserPool';
import AWS from 'aws-sdk';

AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  region: process.env.REACT_APP_AWS_REGION,
});

const cognitoISP = new AWS.CognitoIdentityServiceProvider();

export function HomeLogic() {
  const [showModal, setShowModal] = useState(false);
  const [referralsData, setReferralsData] = useState([]);
  const [users, setUsers] = useState([]);
  const { showAlert, hud, stopHudRotation } = useCustomContext();
  const navigate = useNavigate();
  const referral = new ReferralDS();
  const [selectedUser, setSelectedUser] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  useEffect(() => {
    fetchReferralsData();
    fetchUsers();
  }, []);
  useEffect(() => {
    if (referralsData.length && selectedUser !== "") {
      handleUserChange({ target: { value: selectedUser } });
    }
  }, [referralsData, users]);

  const fetchUsers = async () => {
    hud("Please Wait...");
    try {
      const params = { UserPoolId: userPoolData.userPoolId };
      const data = await cognitoISP.listUsers(params).promise();

      const filteredUsers = data.Users.map(user => {
        const empInfoAttr = user.Attributes.find(attr => attr.Name === 'custom:empInfo');
        const emailAttr = user.Attributes.find(attr => attr.Name === 'email');

        if (!empInfoAttr) return null;

        try {
          const empInfo = JSON.parse(empInfoAttr.Value);
          const userAccessLevel = parseInt(empInfo.accessLevel, 10);

          console.log("username:", user.Username); // ✅ Log here BEFORE return

          return {
            username: user.Username,
            name: empInfo.name || user.Username,
            accessLevel: userAccessLevel,
            email: emailAttr ? emailAttr.Value : null
          };
        } catch (err) {
          console.warn("Invalid JSON in custom:empInfo:", empInfoAttr.Value);
          return null;
        }
      }).filter(Boolean); // Remove null entries

      setUsers(filteredUsers);
      console.log("Filtered Users:", filteredUsers);
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      stopHudRotation();
    }
  };

  const handleUserChange = (e) => {
    const selectedUsername = e.target.value;
    setSelectedUser(selectedUsername);

    if (selectedUsername === "") {
      setFilteredData(referralsData); // ✅ Show all
      console.log("all", referralsData);
      return;
    }

    const selectedUserObj = users.find(user => user.username === selectedUsername);
    if (selectedUserObj) {
      const filtered = referralsData.filter(item => item.referralAddedBy === selectedUserObj.email);
      setFilteredData(filtered); // ✅ Always filter from full dataset
      console.log("filter", filtered);
    }
  };


  const accessLevel = parseInt(localStorage.getItem('accessLevel'), 10);
  const useremail = localStorage.getItem("email");
  const userName = useremail?.split('@')[0];
  const handleViewDetails = (client) => {
    localStorage.setItem('referral_id', client.referralID);
    navigate('/details');
  };

  const handleSaveUser = () => {
    fetchReferralsData();
  };

  const fetchReferralsData = async () => {
    // hud('Please Wait...');
    try {
      let referralEmail = "";

      if (accessLevel === 1) {
        referralEmail = useremail;
      }

      const response = await referral.RM_Referrals_GET({
        referralAddedBy: referralEmail
      });

      let data = response.data.body;

      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (err) {
          console.error("Failed to parse JSON string:", err);
          data = [];
        }
      }

      if (Array.isArray(data)) {
        setReferralsData(data);
        setFilteredData(data); // ✅ make sure filteredData is set
        console.log("referralsData", data);
      } else {
        console.warn("Expected array but got:", data);
        setReferralsData([]);
        setFilteredData([]); // also clear filteredData on failure
      }
    } catch (error) {
      console.error('Error:', error);
      const errorMessage = error.response?.data?.message || error.message || 'An error occurred.';
      showAlert(errorMessage, [{ label: 'Ok', onClick: () => { }, color: 'var(--buttonColor)' }]);
    } finally {
      // stopHudRotation();
    }
  };


  const handleCloseReferral = () => {
    setShowModal(false);
  };

  const handleOpenReferral = () => {
    setShowModal(true);
  };

  const handleReferralSubmit = (formData) => {
    setReferralsData((prev) => [...prev, formData]); // Note: changed from 'setReferrals' to 'setReferralsData'
    setShowModal(false);
  };

  return {
    referralsData,
    showModal,
    handleOpenReferral,
    handleCloseReferral,
    handleReferralSubmit,
    handleSaveUser,
    handleViewDetails, useremail, userName, users, handleUserChange, selectedUser, filteredData
  };
}